import { currentBridgeData } from '@databases/database-state/state/bridge-data';

import { getDatabaseWithCurrentView } from '../../database-view';
import { type AppRootState } from '../../types';

import { canEditContent } from './can-edit-content';

export const shouldShowActionBar = (state: AppRootState): boolean => {
  /**
   * TODO CTD-5030 We need to handle the edge case where a field or entry becomes hidden
   * due to view settings changes by another user. Currently, the view state used
   * in getDatabaseWithCurrentView has stale data.
   */
  const database = getDatabaseWithCurrentView(state, {
    contentId: currentBridgeData.data.contentId
  });
  const selectedValues = state.cellSelections.selectedValues.filter(
    (v) => v.entryId in database.entriesById && v.fieldId in database.fieldsById
  );
  const selectedEntries = state.cellSelections.selectedEntireEntries.filter(
    (id) => id in database.entriesById
  );
  const selectedFields = state.cellSelections.selectedEntireFields.filter(
    (id) => id in database.fieldsById
  );

  const hasValidSelection =
    selectedEntries.length > 0 || selectedFields.length > 1 || selectedValues.length > 1;

  const hasEditAccess = canEditContent(database.operations.updateEntries);

  const canShowActionBar =
    hasEditAccess || (!hasEditAccess && selectedEntries.length === 1);

  return hasValidSelection && canShowActionBar;
};
